import React, { FC } from 'react';
import { Card, CardBody, CardTitle, Col } from 'reactstrap';
import { LinkButton, MaterialIcon, RichMarkdownIt } from '../../../components';
import { useTranslation } from '../../../translations';
import { getConventionIdParam } from '../getConventionIdParam';

export const RegisterComplete: FC = () => {
  const { ts } = useTranslation();
  return (
    <Col lg={6} xs={12}>
      <Card>
        <CardBody className="text-center">
          <div id="regComplete">
            <MaterialIcon className="mb-10" large name="email" type="muted" />
            <CardTitle>{ts('complete.confirm_your_email_address')}</CardTitle>
            <hr />
            <p>{ts('complete.in_order_to_finalize_your')}</p>
            <p>{ts('complete.please_check_your_email_in')}</p>
            <p>{ts('complete.if_you_do_not_confirm')}</p>
            <p>
              <RichMarkdownIt source={ts('complete.email_span_junk')} />
            </p>
            <hr />
            <LinkButton block color="" id="backToLogin" to={`/login${getConventionIdParam()}`}>
              {ts('common.go_back_to_login')}
            </LinkButton>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
